import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {styled} from '@mui/material/styles'
import ErrorMessage from '../../components/FilterPanel/Filters/ErrorMessage.json'

const IconWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  width: '40px',
  height: '40px',
  marginBottom: theme.spacing(1)
}))

const StyledPaper = styled(Paper)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(1.5, 2),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[3],
  background: theme.palette.hpWhite,
  width: '70vw',
  minWidth: 260,
  maxWidth: 520
}))

const StyledTypography = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.body1.fontSize,
  color: theme.palette.hpAccentBlack,
  fontWeight: theme.typography.fontWeightBold,
  marginTop: theme.spacing(0.5)
}))

const StyledContainer = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 140,
  width: '100%',
  position: 'relative'
}))

const StyledErrorIcon = styled(ErrorOutlineIcon)(({theme}) => ({
  color: theme.palette.grey[700],
  fontSize: theme.typography.titleLarge.fontSize
}))

function ChartBlankError() {
  return (
    <StyledContainer>
      <StyledPaper elevation={3}>
        <IconWrapper>
          <StyledErrorIcon />
        </IconWrapper>
        <StyledTypography align='center'>{ErrorMessage.noDataMessage}</StyledTypography>
      </StyledPaper>
    </StyledContainer>
  )
}

export default ChartBlankError
